import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationService } from 'app/modules/configuration/configuration.service';
import { GlobalService } from 'app/services/global.service';
import { PageService } from 'app/services/page-service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-mobileno-sendtemplate',
  templateUrl: './mobileno-sendtemplate.component.html',
  styles: [
  ]
})
export class MobilenoSendtemplateComponent implements OnInit {
  @Input() data: any;
  loader = false;
  successMsg = false
  phoneNo = "";
  sendMobileNoForm: FormGroup;
  phonePattern = environment.phonePattern
    ? environment.phonePattern
    : /^[1-9][0-9]*$/;

  loaderSendBtn = false
  libraryId = ''
  libraryDetails: any
  countryCode: any
  submitted = false;
  confirmDelete = false;

  constructor(
    public dialogRef: NgbActiveModal,
    public global: GlobalService,
    public service: PageService,
    public fb: FormBuilder,
    public configService: ConfigurationService,) { }

  ngOnInit(): void {
    // console.log(this.data)
    this.libraryId = this.data['data'].libraryId
    this.countryCode = this.data['data'].countryCode
    // console.log(this.libraryId, this.libraryDetails, this.countryCode)
    this.sendMobileNoForm = this.fb.group({
      contactNumber: [
        "",
        [
          Validators.required,
          Validators.pattern(this.phonePattern),
          Validators.minLength(10),
          Validators.maxLength(12),
        ],
      ],
      active: false,
    });
  }

  get f() {
    return this.sendMobileNoForm.controls;
  }

  close() {
    this.dialogRef.close({ success: false });
  }

  confirm() {
    this.submitted = true
    this.loader = true
    if (this.sendMobileNoForm.invalid) {
      this.loader = false
      return;
    }
    const formData = this.sendMobileNoForm.value
    const contactNumber = this.countryCode + formData['contactNumber']
    const data = {
      clientName: this.data['data'].clientName,
      params: this.data['data'].params,
      customerNo: contactNumber
    }
    // console.log(data)
    this.loaderSendBtn = true
    this.configService
      .sendTemplate(this.libraryId, data)
      .then((response) => {
        // console.log(response)
        this.loaderSendBtn = false
        this.successMsg = true;
        setTimeout(() => {
          this.successMsg = false;
          this.dialogRef.close({
            success: { result: true},
          });
        }, 3000);
      })
      .catch((err) => {
        this.loader = false;
        this.global.failureErrorModal(err);
      });
  }

}
